import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MemberCard } from './member-card.model';

export interface MemberCardState extends EntityState<MemberCard> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'member-card', idKey: 'MemberId' })
export class MemberCardStore extends EntityStore<MemberCardState> {

  constructor() {
    super();
  }

}

